import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { fundingColors } from '../../theme/figmaColors'

export const useStyles = makeStyles()((theme: Theme) => ({
  list: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: '12px 24px 24px',
    overflowY: 'auto',
  },
  loader: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  programCard: {
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: fundingColors.programCardBg,
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
  },
  title: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: fundingColors.darkText,
  },
  titleButton: {
    padding: 0,
    border: 'none',
    background: 'none',
    color: fundingColors.linkBlue,
    cursor: 'pointer',
    '& svg': {
      fontSize: 14,
    },
  },
  pill: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 24,
    padding: '4px 8px',
    borderRadius: 23,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '0.25px',
    whiteSpace: 'nowrap',
  },
  pillMissing: {
    backgroundColor: fundingColors.warningBg,
    color: fundingColors.negBadgeText,
  },
  pillEligible: {
    backgroundColor: fundingColors.eligiblePillBg,
    color: fundingColors.stepCurrent,
  },
  description: {
    width: '100%',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: fundingColors.mutedText,
  },
  metricsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
  },
  metric: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  metricLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: fundingColors.mutedText,
  },
  metricValue: {
    display: 'inline-flex',
    alignItems: 'baseline',
    letterSpacing: '0.1px',
  },
  metricSymbol: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '20px',
    color: fundingColors.mutedText,
  },
  metricAmount: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: fundingColors.darkText,
  },
  metricMuted: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: fundingColors.mutedText,
  },
  // Only the clickable variant: the badge keeps its look, gains affordance.
  // Take the family off the card but leave the badge's own size/weight alone —
  // the button element would otherwise fall back to the UA font.
  referralLink: {
    cursor: 'pointer',
    fontFamily: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  referralBadge: {
    boxSizing: 'border-box',
    // The metric column stretches its children; keep the badge hugging its
    // content (Figma pill is ~20px wide, not the full column).
    alignSelf: 'flex-start',
    width: 'fit-content',
    minWidth: 20,
    padding: '2px 6px',
    borderRadius: 4,
    border: `1px solid ${fundingColors.buttonBorder}`,
    backgroundColor: theme.palette.common.white,
    color: fundingColors.linkBlue,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    textAlign: 'center',
  },
  reviewBtn: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    borderRadius: 8,
    border: `1px solid ${fundingColors.reviewBorder}`,
    backgroundColor: theme.palette.common.white,
    color: fundingColors.darkText,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  reviewIcon: {
    width: 14,
    height: 14,
  },
}))
